var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",style:({marginBottom: _vm.marginBottom + 'px'})},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('div',{staticClass:"custom"},[_vm._t("custom")],2)]),_c('div',{staticClass:"body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }